var map = {
	"./affiliate-links.svg": 11255,
	"./affiliate-programs.svg": 24923,
	"./affiliation-white.svg": 20312,
	"./bb-academy.svg": 30911,
	"./bb-affiliate-program.svg": 67919,
	"./dashboard.svg": 45994,
	"./finances.svg": 59107,
	"./gdziekupicto.svg": 20084,
	"./payments.svg": 30807,
	"./profile-tipbox.svg": 98076,
	"./reports.svg": 47863,
	"./settings.svg": 45657,
	"./settlements.svg": 41322,
	"./tipbox.svg": 36496,
	"./tips-white.svg": 2772,
	"./widget-bb.svg": 135,
	"./widget-tipbox.svg": 17085,
	"./your-pages.svg": 30204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19006;